export default {
	type: 'object',
	properties: {
		dareSounds: { type: 'object' },
		pledgeSounds: { type: 'object' },
	},
}
